export const state = () => ({
    lastViewed: [],
    needUpdateCatalog: true,
    productsCache: {},
    productModal: null,
});

export const mutations = {
    updateLastViewed(state, newList) {
        state.lastViewed = newList;
    },
    updateNeedUpdateCatalog(state, value) {
        state.needUpdateCatalog = value;
    },
    updateProductCache(state, value) {
        state.productsCache[value.slug] = value.data;
    },
    updateProductModal(state, value) {
        state.productModal = value;
    },
    updateProductModalProduct(state, value) {
        if (state.productModal) {
            state.productModal.product = value;
        } else {
            console.warn("нет родительского товара");
        }
    },
};

export const getters = {
    get(state) {
        return state.lastViewed;
    },
    getNeedUpdateCatalog(state) {
        return state.needUpdateCatalog;
    },
    getProductModal(state) {
        return state.productModal;
    },
};

export const actions = {
    async getProductPageData({ state, commit }, data) {
        const { slug, gender } = data;
        if (!state.productsCache[slug]) {
            const product = await this.$axios.$get(`/api/skus/${slug}`, {
                params: { gender },
            });

            if (!product.size || !product.is_active) {
                this.$router.push(`/404/`);
            }

            const crumbs = [
                {
                    name: this.$i18n.t("cat"),
                    url: `/${gender === "all" ? "woman" : "man"}/`,
                },
                {
                    name: product.product.category.name,
                    url: `/${gender === "all" ? "woman" : "man"}/categories=${product.product.category.slug}`,
                },
                { name: product.product.name + " / " + product.vendor_code },
            ];

            commit("updateProductCache", {
                slug,
                data: {
                    product,
                },
            });

            this.commit("crumbs/change", crumbs);

            if (process.client) {
                // ga("send", "event", "productPage", "pageView");
                (window["rrApiOnReady"] = window["rrApiOnReady"] || []).push(function () {
                    try {
                        rrApi.view(product.id);
                    } catch (e) {
                        console.log(`e =>`, e);
                    }
                });
            }
            // window.scrollTo(0, 0);

            if (process.client) {
                let last = localStorage.getItem("last");
                if (last) {
                    last = last.split(",");
                    last.unshift(product.id);
                    last = last.slice(0, 6);
                    last = [...new Set(last)];
                    localStorage.setItem("last", last.join(","));
                } else {
                    localStorage.setItem("last", product.id);
                }
            }
        }

        return state.productsCache[slug];
    },
    async updateNeedUpdateCatalogAsync({ commit }, value) {
        await new Promise((resolve) => {
            commit("updateNeedUpdateCatalog", value);
            resolve();
        });
    },
    async getLastViewed({ commit }) {
        const ids = localStorage.getItem("last");
        if (ids) {
            try {
                const items = await this.$axios.$get("/api/skus", {
                    // товары которые просят вывести на главной вместо виджета ритейла
                    params: {
                        id: ids.split(","),
                    },
                });
                commit("updateLastViewed", items);
            } catch (error) {
                console.log(`error getLastViewed =>`, error);
            }
        }
    },
};
